import { ACCEPTED_EXTENSIONS, ACCEPTED_FORMATS } from './Constants';

/** Extension first; MIME is secondary (.msg MIME is unreliable across OS). */
export function isAcceptedFileFormat(
  file: File,
  mimeTypes: string[] = ACCEPTED_FORMATS,
  extensions: string[] = ACCEPTED_EXTENSIONS
): boolean {
  const name = file.name.toLowerCase();
  if (extensions.some((ext) => name.endsWith(ext))) {
    return true;
  }
  return mimeTypes.includes(file.type);
}
